import React, { useEffect } from "react";
import { useState, useContext } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/Dhell_Logo.png";
import whiteLogo from "../../../assets/images/Dhell_Logo_White.png";
import { Context } from "../../../Context/AuthContext";
import Cookies from "js-cookie";
import FilledButton from "../../ui/buttons/FilledButton";

const Navbar = () => {
  const [nav, setNav] = useState(true);
  const [logged, setLogged] = useState(false);
  const { values } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    setLogged(values.logIn.isLog);
  }, [values]);

  const handleLogOut = () => {
    Cookies.remove("token");
    values.logIn.setIsLog(false);
    navigate("/");
  };

  const handlenav = () => {
    setNav(!nav);
  };

  return (
    <>
      <header className='hidden md:flex bg-secondary text-white px-10 justify-between items-center h-24'>
        <div className='flex items-center'>
          <Link to='/'>
            <img src={Logo} alt='' className='w-28 h-16' />
          </Link>
        </div>
        <nav className='flex flex-row-reverse gap-16 text-custom-22 text-black font-custom-600'>
          <ul dir='ltr' className='flex gap-12'>
            <Link to='/contact-us'>
              <li className=' hover:text-primary'>تواصل معنا</li>
            </Link>
            <Link to='/aboutus'>
              <li className=' hover:text-primary'>من ظل؟</li>
            </Link>
            <Link to='/find-specialist'>
              <li className='hover:text-primary'>الأخصائيين</li>
            </Link>
            <Link to='/our_services'>
              <li className='hover:text-primary'>خدماتنا</li>
            </Link>
            <Link to='/'>
              <li className='hover:text-primary'>الرئيسية</li>
            </Link>
          </ul>
        </nav>
        <div className='md:mt-0 sm:mt-2 mt-4'>
          {logged ? (
            <Link to='/login'>
              <FilledButton isButton onClick={handleLogOut} text={"تسجيل خروج"} width={"w-48"} height={"h-[3rem]"} />
            </Link>
          ) : (
            <FilledButton path={'/login'} text={"دخول"} width={"w-48"} height={"h-[3rem]"} />
          )}
        </div>
      </header>

      <div
        className={`w-full flex md:hidden justify-end items-center py-4  px-6 md:px-10 text-white bg-secondary`}
      >
        <div className='w-full flex justify-between items-center'>
          <div>
            <Link to='/'>
              <img src={Logo} alt='' className='w-28 h-16' />
            </Link>
          </div>
          <div onClick={handlenav} className='cursor-pointer justify-self-end'>
            {!nav ? (
              <AiOutlineClose color='#591f8b' size={20} />
            ) : (
              <AiOutlineMenu color='#591f8b' size={20} />
            )}
          </div>
        </div>
        <div
          className={
            !nav
              ? "fixed left-0 top-0 w-[60%] z-50 h-full border-r border-r-white bg-primary bg-opacity-[.95] p-4 ease-in-out duration-500 md:hidden"
              : "fixed left-[-100%] w-[60%] top-0 z-50 ease-in-out duration-500 h-full"
          }
        >
          <div>
            <Link to='/'>
              <img src={whiteLogo} alt='white Logo' className='w-28 h-16' />
            </Link>
          </div>
          <ul dir="rtl" className='p-4 text-white '>
            <Link to='/'>
              <li className='py-4 border-b border-white hover:text-primary3'>الرئيسية</li>
            </Link>
            <Link to='/our_services'>
              <li className='py-4 border-b border-white hover:text-primary3'>خدماتنا</li>
            </Link>
            <Link to='/find-specialist'>
              <li className='py-4 border-b border-white hover:text-primary3'>الأخصائيين</li>
            </Link>
            <Link to='/aboutus'>
              <li className='py-4 border-b border-white hover:text-primary3'>من ظل؟</li>
            </Link>
            <Link to='/contact-us'>
              <li className='py-4 border-b border-white hover:text-primary3'>تواصل معنا</li>
            </Link>
            {logged ? (
              <li
                onClick={handleLogOut}
                className='font-bold cursor-pointer py-4 hover:text-primary3'
              >
                تسجيل خروج
              </li>
            ) : (
              <Link to='/login'>
                <li className='font-bold cursor-pointer py-4 hover:text-primary3'>التسجيل</li>
              </Link>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
